(() => {
  if (window.bumpersMobileReviewsReady) return;
  window.bumpersMobileReviewsReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const homepageHiddenReviewIds = new Set([
    '37608000-16b0-49ef-b886-2f9923635011',
    '70a52919-4fc9-49f4-a93e-48a2d214f90b',
    '272db5fc-99b3-4abe-a5b6-e25e904b7b4a',
  ]);

  function enhance(root) {
    if (root.dataset.bumpersReviewsReady || root.classList.contains('jdgm-hidden')) return;
    const viewport = root.querySelector('.jdgm-cards-wrapper');
    const track = root.querySelector('.jdgm-videos-container');
    if (!viewport || !track || !track.querySelector('.jdgm-card:not([data-clone-type])')) return;
    if (root.closest('#customer-stories')) {
      track.querySelectorAll('.jdgm-card[data-review-id]').forEach(card => {
        if (homepageHiddenReviewIds.has(card.dataset.reviewId)) {
          card.style.display = 'none';
          card.dataset.bumpersHiddenReview = 'true';
        }
      });
    }
    root.dataset.bumpersReviewsReady = 'true';
    root.classList.add('bumpers-reviews-mobile');
    // The review app can insert dozens of customer photos at once. Let the browser
    // fetch the ones near the visible cards first so older phones remain responsive.
    track.querySelectorAll('img').forEach(image => {
      image.loading = 'lazy';
      image.decoding = 'async';
    });
    const controls = document.createElement('div');
    controls.className = 'bumpers-review-controls';
    const count = document.createElement('span');
    const pause = document.createElement('button');
    pause.type = 'button';
    controls.append(count, pause);
    root.append(controls);
    viewport.tabIndex = 0;
    viewport.setAttribute('aria-label', 'ביקורות לקוחות, אפשר להחליק ימינה ושמאלה');
    let paused = reducedMotion.matches;
    let visible = false;
    let touching = false;
    let hovered = false;
    let timer;
    let settleTimer;
    const cards = () => Array.from(track.querySelectorAll('.jdgm-card:not([data-clone-type])'))
      .filter(card => getComputedStyle(card).display !== 'none');
    const visibleCards = (items) => Math.max(1, Math.round(viewport.clientWidth / (items[0]?.offsetWidth || viewport.clientWidth)));
    const lastStart = (items) => Math.max(0, items.length - visibleCards(items));
    const current = (items) => {
      const right = viewport.getBoundingClientRect().right;
      return items.reduce((closest, card, index) => {
        const distance = item => Math.abs(item.getBoundingClientRect().right - right);
        return index <= lastStart(items) && distance(card) < distance(items[closest]) ? index : closest;
      }, 0);
    };
    const update = () => {
      const items = cards();
      const first = current(items) + 1;
      const last = Math.min(items.length, first + visibleCards(items) - 1);
      count.textContent = `${first === last ? first : `${first}–${last}`} מתוך ${items.length}`;
      pause.textContent = paused ? 'הפעלת גלילה' : 'השהיית גלילה';
      pause.setAttribute('aria-pressed', String(paused));
    };
    const stop = () => window.clearTimeout(timer);
    const schedule = (delay = 3500) => {
      stop();
      const keyboardFocus = root.contains(document.activeElement) && document.activeElement !== pause && document.activeElement.matches(':focus-visible');
      if (paused || !visible || touching || hovered || document.hidden || keyboardFocus) return;
      timer = window.setTimeout(() => { move(1); schedule(); }, delay);
    };
    const move = (step) => {
      const items = cards();
      if (items.length < 2) return;
      const index = current(items);
      const positions = lastStart(items) + 1;
      const targetIndex = (index + step + positions) % positions;
      const target = items[targetIndex];
      const distance = target.getBoundingClientRect().right - viewport.getBoundingClientRect().right;
      // Native RTL scrolling follows the finger; no mirrored transform or swipe handler.
      viewport.scrollTo({
        left: viewport.scrollLeft + distance,
        behavior: reducedMotion.matches || Math.abs(targetIndex - index) > 1 ? 'auto' : 'smooth',
      });
    };
    root.querySelectorAll('.jdgm-content > .jdgm-arrow').forEach((button, index) => {
      button.setAttribute('aria-label', index === 0 ? 'גלילה שמאלה' : 'גלילה ימינה');
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(index === 0 ? -1 : 1);
        schedule(5000);
      }, true);
    });
    pause.addEventListener('click', () => { paused = !paused; update(); schedule(); });
    viewport.addEventListener('scroll', () => {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(update, 120);
    }, { passive: true });
    // Stop the app's synthetic swipe while retaining the browser's native touch scroll.
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(type => {
      viewport.addEventListener(type, event => {
        event.stopImmediatePropagation();
        touching = type === 'touchstart' || type === 'touchmove';
        touching ? stop() : schedule(5000);
      }, { capture: true, passive: true });
    });
    viewport.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', () => window.setTimeout(schedule, 0));
    root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
    root.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(5000); } });
    document.addEventListener('visibilitychange', () => schedule());
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      schedule();
    }, { threshold: 0.25 }).observe(viewport);
    new ResizeObserver(() => {
      update();
      schedule();
    }).observe(viewport);
    update();
  }
  const observer = new MutationObserver(() => scan());
  const scan = () => {
    const roots = Array.from(document.querySelectorAll('.jdgm-cards-carousel'));
    roots.forEach(enhance);
    if (roots.length && roots.every(root => root.dataset.bumpersReviewsReady)) observer.disconnect();
  };
  observer.observe(document.body, { childList: true, subtree: true });
  scan();
})();
